<template>
  <div>
    <Head :title="__('question.admin.title')" />
    <h1 class="h1">{{ __('question.admin.title') }}</h1>
    <div class="flex items-center justify-between mb-6">
      <div class="column">
        <div class="scrollable mh-[500px] overflow-y-scroll">
          <h2 class="font-semibold md:text-lg mb-4">Prüfungsfragen verwalten</h2>

          <div class="mb-5">
            <label class="form-label" for="name">
              {{ __('question.search') }} {{ keyword }}
            </label>
            <input @input="debounceAnswer" class="form-input" type="text" :placeholder="__('question.search')">
          </div>

          <div class="draggable__wrapper">
            <draggable
                v-model="selectedQuestions"
                @start="drag=true"
                @end="drag=false"
                @change="orderChanged"
                ghost-class="ghost-class"
                item-key="id">
              <template #item="{element, index}">
                <question-list-item
                    :question="element"
                    :index="index" @open-modal="prepareQuestionModal"></question-list-item>
              </template>
            </draggable>
          </div>
          <alert v-if="wasOrderChanged" type="warning" class="">
            <i class="fa fa-info-circle mr-2"></i> {{ __('exam.order_was_changed') }}
          </alert>
          <div class="flex justify-end mt-5 gap-4">
            <button class="btn w-auto inline-flex btn-primary" @click="addQuestion">{{ __('exam.add_question') }}</button>
            <loading-button v-if="wasOrderChanged" :loading="isOrderLoading" class="btn w-auto inline-flex btn-warning" @click="saveOrder" type="submit">
              {{ __('exam.save_order') }}
            </loading-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import draggable from 'vuedraggable'
import QuestionListItem from '../../Shared/Admin/QuestionListItem'
import LoadingButton from '@/Shared/LoadingButton'
import Modal from '@/Shared/Admin/QuestionEditModal'
import Icon from '../../Shared/Icon.vue'

export default {
  components: {
    Head,
    Icon,
    Link,
    QuestionListItem,
    draggable,
    LoadingButton,
    Modal,
  },
  layout: Layout,
  props: {
    filters: Object,
    exams: Object,
    questions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showQuestionModal: false,
      currentQuestion: null, // the selected question
      selectedQuestions: [],
      isTyping: false,
      debounce: null,
      keyword: null,
      timeout: 300,
      isOrderLoading: false,
      drag: false,
      category: null,
      examModel: {},
      isPublishVar: false,
      wasOrderChanged: false,
    }
  },

  mounted() {
    this.selectedQuestions = this.questions
  },

  methods: {

  },
}
</script>
